/*
 * Global functions used in various areas of the site
 * @todo: Continue to refactor and make use of this file or others where it makes sense
 */

export class Global_ISDA_Functions {

	/**
	 * Add class via JS
	 *
	 * @param $el
	 * @param $class
	 */
	vanillaAddClass( $el, $class ) {
		if ( $el.classList ) {
			$el.classList.add( $class );
		} else {
			$el.className += ' ' + className;
		}
	}

	/**
	 * Remove class via JS
	 *
	 * @param $el
	 * @param $class
	 */
	vanillaRemoveClass( $el, $class ) {
		if ( $el.classList ) {
			$el.classList.remove( $class );
		} else {
			$el.className = $el.className.replace( new RegExp( '(^|\\b)' + className.split( ' ' )
			                                                                        .join( '|' ) + '(\\b|$)', 'gi' ), ' ' );
		}
	}

	/**
	 * Has class via JS
	 *
	 * @param elem
	 * @param checkClass
	 * @returns {boolean}
	 */
	vanillaHasClass( elem, checkClass ) {
		return (' ' + elem.className + ' ').indexOf( ' ' + checkClass + ' ' ) > -1;
	}
}